var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { get, set } from '../utils';
import { getSubmitCount } from './selectors';
export var setValueReducer = function (state, _a) {
    var path = _a.path, value = _a.value, shouldValidate = _a.shouldValidate;
    var values = set(state.draft.values, path, value);
    var errors = shouldValidate
        ? state.validate(values, state)
        : state.draft.errors;
    return __assign(__assign({}, state), { draft: __assign(__assign({}, state.draft), { values: values, errors: errors }) });
};
export var setArrayValueReducer = function (state, _a) {
    var path = _a.path, fn = _a.fn;
    return (__assign(__assign({}, state), { draft: __assign(__assign({}, state.draft), { values: set(state.draft.values, path, fn(get(state.draft.values, path))) }) }));
};
export var setTouchedReducer = function (state, _a) {
    var path = _a.path, value = _a.value, shouldValidate = _a.shouldValidate;
    var errors = shouldValidate
        ? state.validate(state.draft.values, state)
        : state.draft.errors;
    return __assign(__assign({}, state), { draft: __assign(__assign({}, state.draft), { touched: set(state.draft.touched, path, value), errors: errors }) });
};
export var submitAttemptReducer = function (state, _a) {
    var errors = _a.errors;
    return (__assign(__assign({}, state), { draft: __assign(__assign({}, state.draft), { errors: errors, submitCount: getSubmitCount(state) + 1 }) }));
};
